module.exports = __webpack_public_path__ + "6493e1cf84095fcccb6679f6f9118d07.jpg";